module.exports = __webpack_public_path__ + "media/images/shop-212346fb2832aa9f4ccf6af35a7808ef.png";